import React, { useEffect, useState } from 'react'
import Paper from '@modul-connect/shared/components/atoms/paper'
import Page from '@modul-connect/shared/components/atoms/page.v2'
import SearchWidget from '@modul-connect/shared/components/molecules/searchWidget.v2'
import { AddTeamVehicleModal } from './addTeamVehicleModal'
import { modifyVehicleToOrganisation } from '../../../state/actions/customer'
import { useAuth0 } from '@auth0/auth0-react'
import { useDispatch, useSelector } from 'react-redux'
import { vehicleTeam_columns } from './team_columns'
import TableWidget from '@modul-connect/shared/components/molecules/tableWidget'

export const TeamVehicle = ({ uuid, parent }) => {

  let filterTimer = null

  const [showAddUserModal, setShowAddUserModal] = useState(false)
  const [vehicles, setVehicles] = useState('')
  const [rowsOptions, setRowsOptions] = useState([])

  const nodeVehicles = useSelector(state => state.organisation_node.vehicles)

  const saving = useSelector(state => state.saving)
  

  
  const { getAccessTokenSilently } = useAuth0()
  const dispatch = useDispatch()

  const addVehicle = (newVehicle) => {
    getAccessTokenSilently()
      .then(token => {
        dispatch(modifyVehicleToOrganisation( 
          token, 
          newVehicle.id, 
          newVehicle.vehicleName,
          newVehicle.model,
          newVehicle.year,
          newVehicle.licenseNumber,
          newVehicle.organisation
        ))
      })
  }

  const removeVehicle = (newVehicle) => {
    getAccessTokenSilently()
      .then(token => {
        dispatch(modifyVehicleToOrganisation( 
          token, 
          newVehicle.id, 
          newVehicle.vehicleName,
          newVehicle.model,
          newVehicle.year,
          newVehicle.licenseNumber,
          newVehicle.organisation,
          true
        ))
      })
  }



  
  const handleNameChange = (event) => {
    setFilterAfterDelay(event.target.value)
  }

  const setFilterAfterDelay = (newFilter) => {
    if (filterTimer) {
      clearTimeout(filterTimer)
    }

    filterTimer = setTimeout(() => {
      setVehicles(newFilter)
    }, 1000)
  }


  const vehicles_prepared = nodeVehicles.map(vehicle => ({
    ...vehicle,
    id: vehicle.id,
    model: vehicle.model,
    licenseNumber: vehicle.licenseNumber,
    year: vehicle.year

  }))


  const sortByColumn = (data, column) => {
    if (!Array.isArray(data) || !column) return data

    if (typeof column !== 'string') column = ''
  
    const isDesc = column.endsWith('desc')
    const key = isDesc ? column.replace(/desc$/i, '') : column
  
    return [...data].sort((a, b) => {
      const v1 = a[key] || ''
      const v2 = b[key] || ''
  
      return isDesc
        ? v2.localeCompare(v1, undefined, { numeric: true })
        : v1.localeCompare(v2, undefined, { numeric: true })
    })
  }

  
  const filteredVehicles = sortByColumn(vehicles_prepared.filter(v =>
    v.vehicleName?.toLowerCase().includes(vehicles.toLowerCase()) ||
    v.id?.toLowerCase().includes(vehicles.toLowerCase()) ||
    v.boxId?.toLowerCase().includes(vehicles.toLowerCase()) ||
    v.modelName?.toLowerCase().includes(vehicles.toLowerCase()) ||
    v.brandName?.toLowerCase().includes(vehicles.toLowerCase()) ||
    v.vehicle?.licenseNumber?.toLowerCase().includes(vehicles.toLowerCase()) ||
    v.vehicle?.year?.toLowerCase().includes(vehicles.toLowerCase())
  ),
  rowsOptions?.sort || 'vehicleName'
  )


  useEffect(() => {
    if (saving) {
      if (saving.addVehicleToOrganisation === null) {
        setShowAddUserModal(false)
      }
    }
  }, [saving])

  const vehiclesToDisplay = !rowsOptions ? filteredVehicles : filteredVehicles.
    slice(rowsOptions.rowsPerPage * (rowsOptions.currentpage -1), filteredVehicles.length)

  return(
    <Page>
      <Paper 
        title={'Vehicles'} 
        linkTitle={'Add vehicle'} 
        onClickLink={() => {setShowAddUserModal(true)}}
      >
        <SearchWidget
          onChange={handleNameChange}
          placeholder={'Search for vehicle...'}
          initialValue={vehicles}
        />
        <AddTeamVehicleModal
          openModal={showAddUserModal}
          onClose={() => {
            setShowAddUserModal(false)
          }}
          addVehicle={addVehicle}
          subOrgId={uuid}
          parent={parent}
          disabled={saving.addVehicleToOrganisation === 'saving'} 
          addingFailed={saving.addVehicleToOrganisation === 'failed'}
        />
        <TableWidget
          data={vehiclesToDisplay}
          columns={vehicleTeam_columns}
          totalItems={filteredVehicles.length}
          defaultSort="vehicleName"
          searchStr={vehicles}
          themes={{ device: 'desktop' }} 
          loadingStatus={false}
          onFetchData={(options) => {
            setRowsOptions(options)
          }}  
          onRemove={(event, id) => {
            const row = filteredVehicles.find(vehicle => vehicle.id === id)
            if (!row) return
            removeVehicle({
              id: row.id,          
              organisation: uuid
            })
          }}
          extend={{ width: '100%', paddingTop: 24 }}
        />
      </Paper>
    </Page>
  )
}